<template>

</template>

<script>
  export default {
     name: 'Property_Maintenacne',
     data () {
       return {
          
        };
     },
     methods: {
    
     }
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Property/Property_Maintenance.vue